import React, { useContext } from "react";
import { observer } from "mobx-react";

import { MyBetsStoreContext } from "@state/context/my-bets/MyBetsStoreContext";
import MyBetsStore from "@state/stores/my-bets/MyBetsStore";
import { Pager } from "@components-shared/mobile/inputs";

export default observer(function PagerWrapper() {
	const myBetsStore = useContext(MyBetsStoreContext);

	if (!(myBetsStore instanceof MyBetsStore)) {
		return null;
	}

	if (!myBetsStore.shouldShowPager) {
		return null;
	}

	return (
		<Pager
			pageNumber={myBetsStore.pageNumber}
			pageSize={myBetsStore.pageSize}
			totalItems={myBetsStore.totalItems}
			onPageChange={myBetsStore.onPageChange}
			withDropdown
		/>
	);
});
